export default __webpack_public_path__ + "static/media/vue-native.97ac1d18.svg";